export default __webpack_public_path__ + "static/media/human_header.341577c0.png";